import { RequestApi } from 'helpers';

// Worker (self) endpoints
const getContacts = (type?: 0 | 1) => {
  const query = type !== undefined ? `?type=${type}` : '';
  return RequestApi.get(`/users/self/contacts${query}`);
};

const addContact = (data: { contactType: 0 | 1; contactValue: string }) => {
  return RequestApi.post(`/users/self/contacts`, data);
};

const deleteContact = (contactId: string) => {
  return RequestApi.delete(`/users/self/contacts/${contactId}`);
};

const setAsPrimary = (contactId: string) => {
  return RequestApi.post(`/users/self/contacts/${contactId}/setasprimary`, {});
};

const verifyContact = (contactId: string) => {
  return RequestApi.post(`/users/self/contacts/${contactId}/verify`, {});
};

// Admin endpoints — operate on a specific user by userId
const getContactsForUser = (userId: string, type?: 0 | 1) => {
  const query = type !== undefined ? `?type=${type}` : '';
  return RequestApi.get(`/users/${userId}/contacts${query}`);
};

const addContactForUser = (userId: string, data: { contactType: 0 | 1; contactValue: string }) => {
  return RequestApi.post(`/users/${userId}/contacts`, data);
};

const deleteContactForUser = (userId: string, contactId: string) => {
  return RequestApi.delete(`/users/${userId}/contacts/${contactId}`);
};

const setAsPrimaryForUser = (userId: string, contactId: string) => {
  return RequestApi.post(`/users/${userId}/contacts/${contactId}/setasprimary`, {});
};

const verifyContactForUser = (userId: string, contactId: string) => {
  return RequestApi.post(`/users/${userId}/contacts/${contactId}/verify`, {});
};

export default {
  getContacts,
  addContact,
  deleteContact,
  setAsPrimary,
  verifyContact,
  getContactsForUser,
  addContactForUser,
  deleteContactForUser,
  setAsPrimaryForUser,
  verifyContactForUser,
};
